import type { Media } from '@/payload-types'

/**
 * Get public URL from a media document or id.
 */
export function getMediaUrl(media: string | Media | null | undefined): string | null {
  if (media == null) return null
  if (typeof media === 'string') return null
  return media.url ?? null
}
